export default __webpack_public_path__ + "static/media/b-H.d44b7e69.png";